<mat-label style="font-size: 12px;margin:10px;" ><a href="https://www.fks.be/" target="_blank">©Fks</a>, {{ "version.version" | translate }} {{ version }}</mat-label>

